<template>
	<div id='register-bg'>
		<div id='register'>
			<h2>新用户注册</h2>
			<el-form :model="registerForm" label-width="100px" size="medium" id='register-form' ref="form" :rules="rules">
				<el-form-item label="邮箱" prop="email">
					<el-input v-model="registerForm.email" placeholder="输入邮箱号" type="email"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input v-model="registerForm.password" type="password" placeholder="设置密码，至少6位" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="comfirm_password">
					<el-input v-model="registerForm.comfirm_password" type="password" placeholder="确认密码" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="phone">
					<el-input v-model="registerForm.phone" placeholder="输入手机号" type="tel"></el-input>
				</el-form-item>
				<el-form-item label="公司" prop="company">
					<el-input v-model="registerForm.company" placeholder="输入公司名"></el-input>
				</el-form-item>
				<el-form-item label="验证码" prop="captcha">
					<el-input v-model="registerForm.captcha" placeholder="输入验证码" style='width: 360px;margin-right: 20px;'></el-input>
					<el-button @click='getVCode' :disabled="isWaiting">{{isWaiting?waitingSeconds+'s':"获取验证码"}}</el-button>
				</el-form-item>
				<el-form-item prop="agreementChecked">
					<el-checkbox v-model="registerForm.agreementChecked">我已阅读并接受<a
							href="http://www.id-photo-verify.com/dev_agreement/" target="_blank">《开发者协议》</a></el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-button @click='apiRegister' type="primary" style='width: 100%'>立即注册</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from "vuex";
	import {
		getVCodeForRegister,
		register
	} from "../api/index.js";
	export default {
		data() {
			var checkPassword = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('密码不能为空'));
				}
				if(value.length<6){
					return callback(new Error('请设置不低于6位的密码'));
				}else{
					callback();
				}
			};
			var checkComfirmPassword = (rule, value, callback) => {
				console.log(rule)
				if (!value) {
					return callback(new Error('请再次输入密码！'));
				}
				if(value!=this.registerForm.password){
					return callback(new Error('两次输入的密码不一致，请重新输入'));
				}else{
					callback();
				}
			};
			var checkAgreementChecked = (rule, value, callback) => {
				if(value){
					callback();
				}else{
					return callback(new Error('请阅读并同意开发者协议！'));
				}
			};
			var checkPhone = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入手机号！'));
				}
				let phoneTest = /^1[3456789]\d{9}$/;
				if(phoneTest.test(value)){
					callback()
				}else{
					return callback(new Error('请输入有效的手机号！'));
				}
			};
			return {
				registerForm: {
					email: "",
					password: "",
					phone: "",
					company: "",
					captcha: "",
					comfirm_password: "",
					agreementChecked: false,
				},
				rules: {
					email: [{
						required: true,
						message: '请输入邮箱',
						trigger: 'blur'
					}],
					password: [{
						validator: checkPassword,
						required: true,
						trigger: 'blur'
					}],
					comfirm_password: [{
						validator: checkComfirmPassword,
						required: true,
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						validator: checkPhone,
						trigger: 'blur'
					}],
					company: [{
						message: '请输入企业名称',
						required: true,
						trigger: 'blur'
					}],
					captcha: [{
						message: '请输入验证码',
						required: true,
						trigger: 'blur'
					}],
					agreementChecked:[{
						type:Boolean,
						validator: checkAgreementChecked,
						trigger: 'blur'
					}]
				},
				isWaiting: false,
				waitingSeconds: 0,
			}
		},
		methods:{
			...mapMutations([
				"setUser"
			]),
			getVCode:function(){
				this.$refs.form.validateField('phone',(errorMessage)=>{
					if(errorMessage){
						return 
					}else{
						getVCodeForRegister(this.registerForm.phone).then(res=>{
							console.log(res)
							if (res.data.code === 200) {
								this.$message("短信验证码已发送")
								this.isWaiting = true;
								let waitingSeconds=60;
								this.waitingSeconds= waitingSeconds;
								var timer=window.setInterval(()=>{
									if (waitingSeconds>1){
										waitingSeconds--;
										this.waitingSeconds= waitingSeconds;
									}else{
										clearInterval(timer)
										this.isWaiting=false;
									}
								},1000)
							} else {
								this.$message.error(res.data.result);
							}
						})
					}
				})
			},
			apiRegister:function(){
				this.$refs.form.validate((boolean)=>{
					if(!boolean){
						return 
					}else{
						register(this.registerForm).then(res=>{
							console.log(res)
							if(res.data.code === 422) {
								this.$message.error("该邮箱已注册");
							} else if (res.data.code === 410) {
								this.$message.error("验证码输入错误");
							} else if (res.data.code === 411) {
								this.$message.error("验证码已过期");
							} else {
								this.$message.success(res.data.result);
								localStorage.setItem('user', this.registerForm.email);
								this.setUser(this.registerForm.email);
								this.$router.replace("/illustrate")
							}
						})
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
	#register-bg{
		background-image: url(../assets/top@2x.png);
		background-position: 0 0;
		background-size: 100% 50%;
		background-repeat: no-repeat;
		height: 100vh;
		padding-top:30px;
	}
	#register{
		margin:30px 40px;
		box-shadow: 0px 4px 12px 0px rgba(66, 66, 66, 0.1);
		background-color: #ffffff;
		border-radius: 10px;
		padding:30px 80px 40px;
		font-size: 16px;
		font-weight: bold;
		color: #4C4C4C;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	#register>h2{
		color: #409EFF;
	}
	#register-form{
		margin-top: 20px;
		width: 600px;
	}
</style>
